import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../shared/Svg';
import './Accordion.scss';

export const Accordion = ({ title, link, status, setStatus, refreshHandler }) => {
  const greyIcon = '#706E6B';
  const expand =
    (
      <Svg
        className={'cheveron'}
        data={'assets/chevrondown.svg'}
        fill={greyIcon}
      />
    );

  const collapse =
    (
      <Svg
        className={'cheveron cheveron-collapse'}
        data={'assets/chevrondown.svg'}
        fill={greyIcon}
      />
    );

  return (
    <div>
      <div className='accordion-header'>
        <div className='accordion-left'>
          <span className='accordion-text'>{title}</span>
          {refreshHandler && <span className='accordion-refresh' onClick={refreshHandler}>
            <Svg
              className={'refresh-icon'}
              data={'assets/refresh.svg'}
            />
          </span>}
        </div>
        <div className='accordion-right'>
          {link}
          <span onClick={() => setStatus(!status)}>{status ? collapse : expand}</span>
        </div>
      </div>
    </div>
  );
};


Accordion.propTypes = {
  title: PropTypes.string,
  link: PropTypes.object,
  setStatus: PropTypes.func,
  status: PropTypes.bool,
  refreshHandler: PropTypes.func,
};
